import type ActiveChannel from '@/common/interfaces/ActiveChannel'
import {injectable} from 'inversify'

@injectable()
export default class ActiveChannelEmployee implements ActiveChannel {
  type: "EMPLOYEE"
  constructor() {
    this.type = "EMPLOYEE"
  }
}
